// Turkish Name Dictionary
// Common names for gender prediction

const MALE_NAMES = new Set([
    'AHMET', 'MEHMET', 'MUSTAFA', 'ALİ', 'HÜSEYİN', 'HASAN', 'İBRAHİM', 'İSMAİL', 'OSMAN', 'YUSUF',
    'MURAT', 'ÖMER', 'RAMAZAN', 'HALİL', 'SÜLEYMAN', 'ABDULLAH', 'MAHMUT', 'SALİH', 'KEMAL', 'RECEP',
    'METİN', 'ADEM', 'YASİN', 'ORHAN', 'BURAK', 'UĞUR', 'GÖKHAN', 'FATİH', 'HAKAN', 'KADİR',
    'EMRE', 'VOLKAN', 'SERKAN', 'SELÇUK', 'SEDAT', 'BEKİR', 'BİLAL', 'YUNUS', 'MESUT', 'İLHAN',
    'ERKAN', 'BÜLENT', 'CEMAL', 'NURİ', 'EKREM', 'ŞABAN', 'EROL', 'MUSA', 'KENAN', 'YAKUP',
    'SAMET', 'SİNAN', 'MURAT', 'ENGİN', 'AYDIN', 'ÖZKAN', 'ERHAN', 'ÖZER', 'HALUK', 'TURAN',
    'FERHAT', 'SERDAR', 'ÜMİT', 'DENİZ', 'ONUR', 'ALPER', 'KEREM', 'FIRAT', 'TOLGA', 'BARIŞ',
    'CAN', 'CEM', 'KAAN', 'MERT', 'EGE', 'EFE', 'ARDA', 'BATUHAN', 'BERKAY', 'BUĞRA',
    'ÇAĞATAY', 'ÇAĞLAR', 'CİHAN', 'DOĞUKAN', 'EMİRHAN', 'ENES', 'EREN', 'FURKAN', 'KORAY', 'LEVENT',
    'OĞUZ', 'OĞUZHAN', 'OKAN', 'OZAN', 'SAFFET', 'SAMİ', 'SELİM', 'SERHAT', 'SONER', 'TARIK',
    'TAYFUN', 'TAYLAN', 'TUNA', 'UFUK', 'UMUT', 'YAVUZ', 'YİĞİT', 'ZAFER', 'ZİYA', 'AKIN',
    'ALPASLAN', 'ALTAN', 'ARİF', 'ATAKAN', 'ATİLLA', 'AYHAN', 'AYKUT', 'AZİZ', 'BAHATTİN', 'BARAN',
    'BAŞAR', 'BAYRAM', 'BERK', 'BİROL', 'BORA', 'CELAL', 'ÇETİN', 'CUMALİ', 'DAVUT', 'DURSUN',
    'EMRAH', 'ERCAN', 'ERDAL', 'ERGÜN', 'ERMAN', 'ERTAN', 'ERTUĞRUL', 'FAHRİ', 'FAİK', 'FARUK',
    'FEHMİ', 'FERDİ', 'FERİT', 'FİKRET', 'GAZİ', 'GÜVEN', 'HALİT', 'HAMDİ', 'HAMZA', 'HARUN',
    'HAYATİ', 'HAYDAR', 'HAYRETTİN', 'HİKMET', 'HİLMİ', 'İDRİS', 'İHSAN', 'İLKER', 'İRFAN', 'İSMET',
    'KAZIM', 'KÜRŞAT', 'LÜTFÜ', 'MEMET', 'MENDERES', 'METE', 'MİTHAT', 'MUAMMER', 'MÜCAHİT', 'MUHAMMED',
    'MUHAMMET', 'MUHARREM', 'MUHİTTİN', 'MÜJDAT', 'MUNİR', 'MÜSLÜM', 'NİLÜFER', 'NİYAZİ', 'NİZAMETTİN', 'NECATİ',
    'NECDET', 'NECMETTİN', 'NECMİ', 'NEJAT', 'NİHAT', 'NOYAN', 'NUMAN', 'NURETTİN', 'OKTAY', 'OLCAY',
    'ÖKKEŞ', 'ÖNDER', 'ORÇUN', 'ÖVÜNÇ', 'ÖZGÜR', 'POLAT', 'RAFET', 'RAHMİ', 'RAŞİT', 'REMZİ',
    'RIDVAN', 'RIZA', 'RÜŞTÜ', 'SABRİ', 'SADIK', 'SADETTİN', 'SAİT', 'ŞAKİR', 'SAMİM', 'SAVAŞ',
    'SEÇKİN', 'SEFER', 'SELAHATTİN', 'SELAMİ', 'ŞENER', 'SERBAY', 'SERBÜLENT', 'SERGEN', 'SERTAN', 'SERVET',
    'SEYFETTİN', 'SEYFİ', 'SEYİT', 'SEZAİ', 'ŞÜKRÜ', 'SUAT', 'TACETTİN', 'TAHİR', 'TAHSİN', 'TAMER',
    'TANER', 'TANJU', 'TARKAN', 'TEKİN', 'TEMEL', 'TEVFİK', 'TİMUR', 'TUNCİL', 'TUNCAY', 'TUNÇ',
    'TURGAY', 'TURGUT', 'UFUK', 'ÜNAL', 'VEDAT', 'VEYSEL', 'VOLKAN', 'YALÇIN', 'YAŞAR', 'YILDIRIM',
    'YILMAZ', 'YÜCEL', 'YÜKSEL', 'ZEKİ', 'ZEYNEL', 'ÜZEYİR', 'MURATHAN', 'BERKE', 'BEDİRHAN', 'EMİR',
    'TALHA', 'GÖKTUĞ', 'GÖRKEM', 'ANIL', 'RUSLAN', 'MUSAB', 'MERTCAN', 'ERSİN', 'CENGİZ', 'BİNAY', 'CENGİZHAN',
    'ALİ', 'AHMET', 'MESUT', 'ARDA', 'ÜNAL', 'KEMAL', 'İBRAHİM', 'YUSUF', 'MURAT', 'KADİR', 'ÖMER',
    'SELAHATTİN', 'BAYRAM', 'EMRE', 'HASAN', 'ENES', 'İSMAİL', 'ALTAN', 'MERT', 'FURKAN', 'TAHA',
    'MEHMET', 'ERKAN', 'OSMAN', 'SEYHAN',
    // Modern/Popüler İsimler
    'RÜZGAR', 'ÇINAR', 'TOPRAK', 'ATLAS', 'MİRAÇ', 'EYMEN', 'POYRAZ', 'KUZEY', 'ÖMER ASAF', 'YUSUF ALİ'
]);

const FEMALE_NAMES = new Set([
    'FATMA', 'AYŞE', 'EMİNE', 'HATİCE', 'ZEYNEP', 'ELİF', 'MERYEM', 'ŞERİFE', 'SULTAN', 'HANİFE',
    'HAVVA', 'HAYRİYE', 'ZELİHA', 'CEMİLE', 'ZEHRA', 'HÜLYA', 'SEVİM', 'FATMA', 'GÜL', 'AYSEL',
    'NECLA', 'LEYLA', 'SEMA', 'DİLEK', 'YASEMİN', 'FİLİZ', 'NURAY', 'ESRA', 'ÖZLEM', 'SİBEL',
    'ARZU', 'CANAN', 'NURTEN', 'NURAN', 'SEVİL', 'GÜLAY', 'AYTEN', 'AYŞEGÜL', 'EMEL', 'SEVGİ',
    'AYLİN', 'ASLI', 'BURCU', 'ÇİĞDEM', 'EBRU', 'FUNDA', 'GAMZE', 'GİZEM', 'GÖZDE', 'GÜLŞAH',
    'HANDE', 'KÜBRA', 'MELİKE', 'MELTEM', 'MERVE', 'NİHAL', 'NİLÜFER', 'ÖZGE', 'PELİN', 'PINAR',
    'RABİA', 'REYHAN', 'SEDA', 'SELDA', 'SELMA', 'SEMRA', 'SENEM', 'SERAP', 'ŞEYMA', 'SİNEM',
    'SONGÜL', 'ŞULE', 'SÜMEYYE', 'TUĞBA', 'TÜLAY', 'TÜLİN', 'ÜLKÜ', 'YEŞİM', 'YONCA', 'ZUHAL',
    'ADAM', // Bazı unisex isimler karışabilir, dikkat
    'ASİYE', 'ASUMAN', 'AYFER', 'AYNUR', 'AYŞEN', 'AYŞENUR', 'AZİZE', 'BAHAR', 'BAHRİYE', 'BANU',
    'BAŞAK', 'BEDİA', 'BEDRİYE', 'BEHİYE', 'BELGİN', 'BELKIS', 'BENGÜ', 'BERFİN', 'BERNA', 'BERRİN',
    'BETÜL', 'BEYHAN', 'BEYZA', 'BİLGE', 'BİLGİN', 'BİNNAZ', 'BİNNUR', 'BİRCAN', 'BİRGÜL', 'BİRSEN',
    'BUKET', 'BÜŞRA', 'CAHİDE', 'CANSU', 'CEVRİYE', 'CEYDA', 'CEYLAN', 'DAMLA', 'DEMET', 'DENİZ', // Deniz Unisex ama genelde kadın da çok
    'DERYA', 'DİDEM', 'DİLAN', 'DİLARA', 'DÖNDÜ', 'DUDU', 'DUYGU', 'ECE', 'EDA', 'ELMAS',
    'EMİNE', 'ESEN', 'ESMA', 'ESMERAY', 'EVRİM', 'EYLEM', 'EZGİ', 'FADİME', 'FAHRİYE', 'FATMANUR',
    'FATOŞ', 'FEHİME', 'FERDA', 'FERİDE', 'FEYZA', 'FİGEN', 'FİKRIYE', 'FİRDEVS', 'FULYA', 'FÜSUN',
    'GÖNÜL', 'GÜLBAHAR', 'GÜLBEN', 'GÜLÇİN', 'GÜLDEN', 'GÜLER', 'GÜLFİDAN', 'GÜLHAN', 'GÜLİSTAN', 'GÜLİZAR',
    'GÜLLÜ', 'GÜLNUR', 'GÜLPERİ', 'GÜLSÜM', 'GÜLŞEN', 'GÜLTEN', 'GÜZİDE', 'HACER', 'HALİDE', 'HALİME',
    'HAMİYET', 'HANDAN', 'HASİBE', 'HATİCE', 'HAVA', 'HAVVA', 'HAYRÜNNİSA', 'HAZAL', 'HİCRAN', 'HİLAL',
    'HURİYE', 'İCLAL', 'İDİL', 'İFEC', 'İKBAL', 'İKNUR', 'İLAYDA', 'İLKAY', 'İLKNU', 'İMRAN',
    'İNCİ', 'İPEK', 'İREM', 'JALE', 'JÜLİDE', 'KADRİYE', 'KAMİLE', 'KEZBAN', 'KIYMET', 'KİRAZ',
    'KUDRET', 'LALE', 'LATİFE', 'LEMAN', 'LERZAN', 'LÜTFİYE', 'MACİDE', 'MAKBULE', 'MEDİHA', 'MEHTAP',
    'MELEK', 'MELİHA', 'MELİSA', 'MENEKŞE', 'MERAL', 'MERİÇ', 'MERİH', 'MERYEM', 'MESUDE', 'MİNE',
    'MİRAY', 'MUAZZEZ', 'MÜEŞŞER', 'MÜJGAN', 'MUKADDES', 'MÜNİRE', 'MÜRÜVVET', 'MÜŞERREF', 'NACİYE', 'NADİDE',
    'NADİRE', 'NAGİHAN', 'NAHİDE', 'NALAN', 'NAZAN', 'NAZLI', 'NAZMİYE', 'NEBAHAT', 'NEBİLE', 'NECMİYE',
    'NEDRET', 'NEFİSE', 'NEHİR', 'NERİMAN', 'NERMİN', 'NESLİHAN', 'NESRİN', 'NEVİN', 'NEVRA', 'NEZAHAT',
    'NEZAKET', 'NİGAR', 'NİLGÜN', 'NİSA', 'NUR', 'NURCAN', 'NURDAN', 'NURGÜL', 'NURHAN', 'NURİYE',
    'NURSEL', 'NURŞEN', 'OYA', 'ÖZDEN', 'ÖZNUR', 'PAKİZE', 'PERİHAN', 'PERİ', 'PERVİN', 'PETEK',
    'RAHİME', 'RAZİYE', 'REMZİYE', 'REYYAN', 'ROJDA', 'ROJİN', 'RUKİYE', 'SAADET', 'SABİHA', 'SABİRE',
    'SABRİYE', 'SADİYE', 'SAFİYE', 'SAKİNE', 'SALİHA', 'SANEM', 'SANİYE', 'SEÇİL', 'SEDEF', 'SEHER',
    'SELİN', 'SELMA', 'SELVİ', 'SEMAHAT', 'SEMİHA', 'SEMİRAMİS', 'SENİHA', 'SERAY', 'SERPİL', 'SEVAL',
    'SEVDA', 'SEVGİ', 'SEVİL', 'SEVİLAY', 'SEVİNÇ', 'SEYHAN', 'SILA', 'SİMGE', 'SOLMAZ', 'SONAY',
    'SONGÜL', 'SUZAN', 'ŞADİYE', 'ŞAHİNDE', 'ŞAZİYE', 'ŞEBNEM', 'ŞEFİKA', 'ŞEHNAZ', 'ŞENGÜL', 'ŞENNUR',
    'ŞERMİN', 'ŞEYDA', 'ŞÜKRAN', 'ŞÜKRİYE', 'TÜRKAN', 'ÜMMÜ', 'ÜMMÜHAN', 'VİLDAN', 'YILDIZ', 'ZAHİDE',
    'ZEKİYE', 'ZERRİN', 'ZEYNEP', 'ZÜBEYDE', 'ZÜHAL', 'ZÜLAL', 'ZÜLEYHA', 'ZÜMRÜT',
    'BANU', 'ESLEM', 'EZGİ', 'NURDAN', 'İREM', 'CANSU'
]);

export class GenderPredictor {
    // Normalize name: UPPERCASE, trim, remove special chars if any
    static normalize(name: string): string {
        if (!name) return '';
        return name
            .trim()
            .toLocaleUpperCase('tr-TR')
            .split(' ')[0]; // Use first name only
    }

    static predict(fullName: string): 'male' | 'female' | null {
        if (!fullName) return null;

        // Split by spaces and take the first part as the name
        const parts = fullName.trim().split(/\s+/);
        const firstName = this.normalize(parts[0]);

        if (!firstName) return null;

        if (MALE_NAMES.has(firstName)) {
            return 'male';
        }

        if (FEMALE_NAMES.has(firstName)) {
            return 'female';
        }

        // Try second name if first name is not found and exists
        if (parts.length > 1) {
            const secondName = this.normalize(parts[1]);
            if (MALE_NAMES.has(secondName)) return 'male';
            if (FEMALE_NAMES.has(secondName)) return 'female';
        }

        return null;
    }

    static getGenderLabel(gender: string | null): string {
        if (gender === 'male') return 'Erkek';
        if (gender === 'female') return 'Kadın';
        return 'Belirsiz';
    }
}
